<template>
  <div class="modals-wrapper">
    <b-modal id="visume_mode" ref="video_mode" class="visume-Model" hide-header hide-footer no-close-on-backdrop @show="resetModal" @hidden="closeModal">
      <div class="modal-header pl-0" style="">
          <h5 v-if="this.startRecording">Record your video</h5>
          <a id="skip-visume" v-on:click="showConfirmation" v-if="this.startRecording" style="color:#a5a5a5;cursor: pointer; margin-left:140px;">x</a>
      </div>
      <form ref="addVisume-form" action="">
        <div id="interactive" class="viewport">
          <div>
            <video id="video_resume" width="460" height="345" type="video/*" controls v-if="videoResume" :src="$S3_bucket_url+this.visume"></video>
            <video id="video_view" width="460" height="345" autoplay muted type="video/*" v-if="videoView"></video>
            <video id="video_preview" width="460" height="345" type="video/*" controls v-show="videoPreview"></video>
            <div id="time-interval" style="position: absolute; right: 30px;display:flex;top:75px;">
              <v-icon style="color:#da0e0e" class="mt-1 mr-1" size="14px">{{$icons.radioboxMarked}}</v-icon>
              <div class="timeee margin-left-7 display-inline" style="color: #000" id="video_min">00</div>
              <div class="display-inline">:</div>
              <div class="timeee display-inline margin-right-7" style="color: #000" id="video_sec">00</div>
            </div>
            <div id="countdown">
              <div id="countdown-number"></div>
              <svg style="display: none">
                <circle r="18" cx="20" cy="20"></circle>
              </svg>
            </div>
          </div>
          <div class="error_feedback" v-if="visume_error">{{visume_err_msg}}</div>
          <button id="startButton" @click.prevent="Updating" class="btn up-visume-btn updateVideo mt-2" v-if="updateVisume"><span></span>Update Visume</button>
          <p class="disclaimer" v-if="updateVisume">Feel like improving your introduction ? Yes, you can update your visume. <br> <span> video profile will be visible to active recruiters  & they can shortlist you by reviewing this video profile.</span></p>
          <button id="startButton" @click.prevent="startRecord" class="btn up-visume-btn start mt-2" v-if="startRecording"><span></span> Start recording</button>
          <p class="disclaimer" v-if="startRecording && !hideDefaultMessage">Record your 2 minute video profile. You can brief about yourself, your abilities, skills & why a company should hire you. Don’t worry,  you can update your  visume again.<br> <span> video profile will be visible to active recruiters  & they can shortlist you by reviewing this video profile.</span></p>
          <p class="disclaimer" v-if="startRecording && hideDefaultMessage">{{ this.message }}<br></p>
          <button id="stpButton" @click.prevent="funcStopRecording" class="btn up-visume-btn stopVideo mt-2" v-if="stopRecord"><span></span> Stop recording</button>
          <p id="waiting" class="btn up-visume-btn stopVideo mt-2" v-if="waiting">Uploading your visume, please wait ...</p>
          <p class="disclaimer" v-if="stopRecord && !hideDefaultMessage">Record your 2 minute video profile. You can brief about yourself, your abilities, skills & why a company should hire you. Don’t worry,  you can update your  visume again.<br> <span> video profile will be visible to active recruiters  & they can shortlist you by reviewing this video profile.</span></p>
          <p class="disclaimer" v-if="stopRecord && hideDefaultMessage">{{ this.message }}<br></p>
          <button id="checkRecord" @click.prevent="recordAgain" class="btn up-visume-btn retakeVideo mt-2" v-if="checkRecord"><span></span> Record Again</button>
        </div>
      </form>
    </b-modal>
    <b-modal id="confirmation-visume" ref="confirmation-visume" title=" " hide-footer hide-header>
      <div class="container">
        <p style="font-size:13px !important;"><strong>Are you sure you want to skip video recording?</strong></p>
      </div>
      <div class="modal-footer justify-content-center" style="border-top:none;">
        <button type="button" class="btn btn-secondary" v-on:click="skipVisume">Skip</button>
        <button type="button" class="btn btn-danger" data-dismiss="modal" v-on:click="hideModal">Record Video</button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import AwsUpload from "../../utils/s3upload"
import Actions from '../libraries/apiActions.js';

export default {
  name: "VideoModal",
  props: {
    open: String,
    visume: String,
    email_status: Number,
    hideDefaultMessage: {
      type: Number,
      default: 0
    },
    message: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      apiAction: new Actions(),
      count: 3,
      streamActive: false,
      mediaRecorder: "",
      start: false,
      hasWorkingDevices: false,
      constrains: {
        audio: true,
        video: {
          minAspectRatio: 1.333,
          minFrameRate: 60,
          width: 640,
          heigth: 480,
        },
      },
      options: {
        audioBitsPerSecond: 128000,
        videoBitsPerSecond: 150000,
        mimeType: "video/webm;codecs=vp9",
      },
      data:{
        video:''
      },
      stream: "",
      recordedBlobs: [],
      checkRecording: false,
      OverAllVideoCoundownTimer: "",
      sec: 0,
      duration:0,
      min: 0,
      timer_is_on: 0,
      startRecording:false,
      addVideo:false,
      checkRecord:false,
      stopRecord:false,
      videoView:false,
      videoPreview:false,
      videoResume:false,
      updateVisume: false,
      waiting: false,
      waiting_percentage:null,
      visume_error:false,
      visume_err_msg:null,
      video_start_time: null,
      video_end_time: null
    };
  },
  methods: {
    openModal: async function (type = "") {
      this.open = type == "" ? this.open : type;
      if (this.open == "video") {
        this.$refs["video_mode"].show();
        this.videoPreview = false;
        this.videoView = true;
        this.videoResume = false;
        this.startRecording = true;
        this.updateVisume = false;
        this.checkDevicesWroking();
      }
    },
    resetModal() {
      this.count = 3,
      this.streamActive = false,
      this.mediaRecorder = "",
      this.start = false,
      this.hasWorkingDevices = false,
      this.startRecording = true
      this.addVideo = false,
      this.checkRecord = false,
      this.stopRecord = false,
      this.videoView = true,
      this.videoPreview = false,
      this.recordedBlobs=[],
      this.checkRecording= false,
      this.OverAllVideoCoundownTimer="",
      this.sec= 0,
      this.min=0,
      this.timer_is_on=0,
      this.data.video = '',
      this.stream = "",
      this.waiting = false,
      this.visume_error = false,
      this.visume_err_msg = null
    },
    closeModal(){
      this.$refs["video_mode"].hide();
    },
    Updating(){
      this.videoPreview = false;
      this.videoView = true;
      this.videoResume = false;
      this.startRecording = true;
      this.updateVisume = false;
      this.checkDevicesWroking();
    },
    handleOk(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault();
      // Trigger submit handler
      this.handleSubmit();
    },
    handleSubmit() {
      // Exit when the form isn't valid
      if (!this.checkFormValidity()) {
        return;
      }
      // Hide the modal manually
      this.$nextTick(() => {
        this.$bvModal.hide("modal-prevent-closing");
      });
    },
    handleStream: async function () {
      this.hasWorkingDevices = true;
      window.stream = await navigator.mediaDevices
        .getUserMedia(this.constrains)
        .then((stream) => {
          document.getElementById("video_view").srcObject = stream;
          console.log('the stream is', stream);
          this.streamActive = true;
          return stream;
        });
      //  document.querySelector('video').srcObject = stream;
      document.getElementById("video_view").srcObject = window.stream;
      document.getElementById("video_view").play();
      //
      this.PlayRecodingToUser();
    },
    notsupportingRecording: function () {
      alert("Your system does not support recording");
      window.alert('Enable your camera to capture video resume')
    },
    handleMediaSupportError: function (err) {
      console.log(err);
      window.alert('Enable your camera to capture video resume')
    },
    handleAvalibleData: function (e) {
      if (e.data && e.data.size > 0) {
        this.recordedBlobs.push(e.data);
      }
    },
    handleStart: function () {
      this.recordedBlobs = [];
      this.checkRecording = false;
      if (this.mediaRecorder.state == "recording") {
        this.video_start_time = Date.now();
        console.log("recording");
      } else {
        console.log("error");
      }
    },
    //TIMER CODE STARTS
    overAllVideoCoundown: function () {
      var self = this;
      ++this.sec;
      if (this.sec == 59) {
        this.sec = 0;
        this.min = parseInt(this.min) + 1;
      }
      var pat = /^[0-9]{1}$/;
      this.sec = pat.test(this.sec) == true ? "0" + this.sec : this.sec;
      this.min = pat.test(this.min) == true ? "0" + this.min : this.min;
      document.getElementById("video_min").innerHTML = this.min;
      document.getElementById("video_sec").innerHTML = this.sec;
      if (this.min == "02") {
        this.funcStopRecording();
        return;
      }
      this.OverAllVideoCoundownTimer = setTimeout(function () {
        self.overAllVideoCoundown();
      }, 1000);
    },
    //START VIDEOCOUNTDOWN
    startVideoCount: function () {
      if (!this.timer_is_on) {
        this.timer_is_on = 1;
        this.overAllVideoCoundown();
      }
    },
    //STOP VIDEOCOUNTDOWN
    stopVideoCount: function () {
      clearInterval(this.OverAllVideoCoundownTimer);
      this.timer_is_on = 0;
    },
    handleStop: function () {
      this.stopVideoCount();
      this.video_end_time = Date.now();
      this.uploadFile(this.recordedBlobs);
      this.videoPreview = true;
      this.videoView = false;
      this.startPreviewVideo();
    },
    startPreviewVideo: function() {
      var superBuffer = new Blob(this.recordedBlobs, {type: 'video/mp4'});
      var src = window.URL.createObjectURL(superBuffer);
      document.getElementById("video_preview").removeAttribute('src');
      document.getElementById("video_preview").src = src;
    },
    checkDevicesWroking: function () {
      if (navigator.mediaDevices) {
        navigator.mediaDevices
          .getUserMedia(this.constrains)
          .then(this.handleStream())
          .catch((error) => this.handleMediaSupportError(error));
      } else {
        this.hasWorkingDevices = false;
        this.notsupportingRecording();
      }
    },
    // //STREAMING VIDEOS
    PlayRecodingToUser: function () {
      if (!document.getElementById("video_view").paused) {
        //START MEDIA RECORDER
        this.startMediaRecorder();
      } else {
        this.hasWorkingDevices = false;
        this.notsupportingRecording();
      }
    },
    recordVisume: async function () {
      this.stream = navigator.mediaDevices.getUserMedia({
        video: {
          minAspectRatio: 1.333,
          minFrameRate: 60,
          width: 640,
          heigth: 480,
        },
        audio: true,
      });
      document.querySelector("video").srcObject = this.stream;
      if (this.stream.active) {
        this.streamActive = true;
      }
    },
    getCount: function (limit) {
      var countdownNumberEl = document.getElementById("countdown-number");
      var countdown = limit;
      countdownNumberEl.textContent = countdown;
      document.querySelector("svg").style.display = "block";
      return new Promise(function (resolve) {
        var countInterval = setInterval(function () {
          if (countdown <= 0) {
            clearInterval(countInterval);
            document.querySelector("svg").style.display = "none";
            document.getElementById("countdown-number").style.display = "none";
            // this.start = true;
            resolve("done");
          }
          countdown = countdown - 1;
          countdownNumberEl.textContent = countdown;
        }, 600);
      });
    },
    startMediaRecorder: function () {
      if (this.hasWorkingDevices) {
        if (MediaRecorder) {
          if (!MediaRecorder.isTypeSupported(this.options.mimeType))
            this.options = { mimeType: "video/webm;codecs=vp8" };
          else if (!MediaRecorder.isTypeSupported(this.options.mimeType))
            this.options = { mimeType: "video/webm" };
          else if (!MediaRecorder.isTypeSupported(this.options.mimeType))
            this.options = { mimeType: "" };
        } else {
          this.hasWorkingDevices = false;
          this.notsupportingRecording();
          return;
        }
        try {
          this.mediaRecorder = new MediaRecorder(window.stream, this.options);
          //showRecordingStartState();
          // $('#video-record-block').addClass('display-none');
          // $('#third_step').removeClass('display-none');
          this.mediaRecorder.ondataavailable = this.handleAvalibleData;
          this.mediaRecorder.onstart = this.handleStart;
          this.mediaRecorder.onstop = this.handleStop;
          // mediaRecorder.onresume = handleResume;
          // mediaRecorder.onpause = handlePause;
          // mediaRecorder.onerror = handleError;
        } catch (e) {
          console.log(e);
        }
      } else {
        this.hasWorkingDevices = false;
        this.notsupportingRecording();
      }
    },
    startRecord: async function () {
      if (this.streamActive) {
        // var self = this;
        // document.getElementById("startButton").style.display = "none";
        this.startRecording = false;
        // document.getElementById("stpButton").style.display = "inline-block";
        this.checkRecord = false;
        this.addVideo = false;
        this.stopRecord = true;
        this.getCount(5).then((res) => {
          if ((res == "done") & this.hasWorkingDevices) {
            (this.sec = 0),
              (this.min = 0),
              (document.getElementById("time-interval").style.display = "flex");
            this.startVideoCount();
            this.mediaRecorder.start(10);
          }
        });
      }
    },
    funcStopRecording: function () {
      if (this.hasWorkingDevices && this.mediaRecorder.state == "recording") {
        this.stopRecord = false;
        // this.checkRecord = true;
        // this.addVideo = true;
        this.waiting = true;
        this.stopRecording = false;
        this.handleStop();
        // document.getElementById("wait").style.display = "block";
      }
    },
    async uploadFile(blob) {
      const file = new Blob(blob, { type: "application/octet-binary" });
      const awsUploader = new AwsUpload();

      if (file.size < 20000000) {
        try{
          var d = new Date();
          var month = d.getMonth() + 1;
          var day = d.getDate();
          var current_date =d.getFullYear() +"/" +(month < 10 ? "0" : "") +month +"/" +(day < 10 ? "0" : "") +day;
          var timestamp = Math.floor(Date.now() / 1000);
          var filename = 'visume/'+ current_date+"/profile_visume"+ timestamp + ".mp4";
          const response = await awsUploader.uploadToS3(file, filename);
          this.data.video = response.url;
          this.$emit('video_path',this.data.video);
          if(window.stream){
            const tracks = window.stream.getVideoTracks();
            tracks.forEach(track => track.stop())
          }
          this.$refs['confirmation-visume'].hide();
          this.$refs['video_mode'].hide();
        } catch (error) {
          console.error('Failed to upload file to S3:', error);
          this.visume_error = true;
          this.visume_err_msg = "System error! Please try again.";
          this.startRecording = true;
          this.checkRecord = true;
        }
      }
    },
    recordAgain(){
      this.startRecording = true
      this.addVideo = false,
      this.checkRecord = false,
      this.stopRecord = false,
      this.videoView = true,
      this.videoPreview = false,
      this.recordedBlobs=[],
      this.checkRecording= false,
      this.OverAllVideoCoundownTimer="",
      this.sec= 0,
      this.min=0,
      this.timer_is_on=0;
    
      var pat = /^[0-9]{1}$/;
      this.sec = pat.test(this.sec) == true ? "0" + this.sec : this.sec;
      this.min = pat.test(this.min) == true ? "0" + this.min : this.min;
      document.getElementById("video_min").innerHTML = this.min;
      document.getElementById("video_sec").innerHTML = this.sec;
      this.checkDevicesWroking();
    },
    showConfirmation(e){
      e.preventDefault();
      this.$refs['confirmation-visume'].show();
    },
    hideModal(){
      this.$refs['confirmation-visume'].hide();
    },
    skipVisume(e){
      e.preventDefault();
      // const video = document.querySelector('video');
      // const mediaStream = video.srcObject;
      // const tracks = mediaStream.getTracks();
      // tracks.forEach(track => track.stop())
      if(window.stream){
        const tracks = window.stream.getVideoTracks();
        tracks.forEach(track => track.stop())
      }
      this.$refs['confirmation-visume'].hide();
      this.$refs['video_mode'].hide();
    }
  },
  watch: {
    open: {
      handler() {
        this.openModal();
      },
      deep: true,
    },
  },
  mounted() {
    this.$refs['video_mode'].$on("hidden", () => {
      this.$emit('reset_modal');
      this.open = "";
    });
  }
};
</script>
<style>
 #visume_mode .modal-header{padding: 10px 10px 0px 15px;border: none;}#visume_mode .modal-header .modal-title{color: #212529;font-size: 17px;}p.disclaimer{font-size: 10.5px;margin-top: 10px;margin-bottom: 5px;color: #808080;min-height: 52px;line-height: 13px;}p.disclaimer span{font-style: italic;color: #b3b3b3;}.up-visume-btn{font-weight: bold;width: auto;}.up-visume-btn.start span{display: inline-block;width: 30px;height: 30px;border: solid 6px #fff;background: #e30613;border-radius: 50px;vertical-align: top;margin-right: 5px;margin-top: -4px;}.up-visume-btn.stopVideo span{display: inline-block;width: 30px;height: 30px;background:#ffffff ;border-radius: 50px;vertical-align: top;margin-right: 5px;margin-top: -4px;border: solid 9px #e30613;}.up-visume-btn.addvdo span{display: inline-block;width: 30px;height: 30px;background:#008f58 ;border-radius: 50px;vertical-align: top;margin-right: 5px;margin-top: -4px;border: solid 3px #fff;}.up-visume-btn.retakeVideo span{display: inline-block;width: 30px;height: 30px;border: solid 6px #fff;background: #e30613;border-radius: 50px;vertical-align: top;margin-right: 5px;margin-top: -4px;}.up-visume-btn.updateVideo span{display: inline-block;width: 30px;height: 30px;border: solid 1px #fff;background: #007bff;border-radius: 50px;vertical-align: top;margin-right: 5px;margin-top: -4px;}.up-visume-btn.updateVideo span::after{content: "↻";color: #fff;text-align: center;font-size: 18px;}.up-visume-btn.addvdo span::after{content: "+";color: #fff;text-align: center;font-size: 17px;}.up-visume-btn:hover{color: #808080;}.up-visume-btn:hover span{background: #007bff;}#visume_mode .modal-content{border-radius: 0px;background:#e6e7e8 ;min-height: 523px;}#visume_mode .modal-body{padding: 0px 15px 15px 15px;}#visume_mode .modal-body .viewport #video_view, #video_preview, #video_resume {border-radius: 20px;width: 100%;height: auto;}#countdown {position: absolute;top: 40%;left: 50%;height: 40px;width: 40px;text-align: center;}#countdown-number {color: #003e80;display: inline-block;line-height: 40px;}#countdown>svg {position: absolute;top: 0;right: 0;width: 40px;height: 40px;transform: rotateY(-180deg) rotateZ(-90deg);}svg circle {stroke-dasharray: 113px;stroke-dashoffset: 0px;stroke-linecap: round;stroke-width: 4px;stroke: #003e80;fill: none;animation: countdown 4s linear;}#interactive {text-align: center;}.display-none {display: none;}#camera_alert .modal-header{border-bottom: 0px !important;padding-bottom: 0px !important;}#camera_alert .modal-body{padding-top: 0px !important;}@keyframes countdown {from {stroke-dashoffset: 0px;}to {stroke-dashoffset: 113px;}}@media only screen and (max-width: 991px){.up-visume-btn{font-size: 14px;width: 152px;}.up-visume-btn span{display: block !important;margin-left: 35%;margin-bottom: 3px;}#visume_mode .modal-content{min-height: 450px;}}#visume_mode .modal-header {color: #003e80 !important;font-size: 11px !important;}
</style>
